"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.savedQuoteSelector = exports.ownerEmailSelector = void 0;
var savedQuoteSelector = exports.savedQuoteSelector = function savedQuoteSelector(state) {
  return state.quote;
};
var ownerEmailSelector = exports.ownerEmailSelector = function ownerEmailSelector(state) {
  return state.quote.quote.owner.email;
};